<template>
  <v-sheet :rounded="isSmallerDisplay() ? '' : 'lg'" class="text-center pa-6">
    <div class="text-h4 mb-4">{{$t('message.page_not_found')}}</div>
    <IconLike size="200px" class="rotate-90" :color="themeColor('error')"></IconLike>
  </v-sheet>
</template>

<script>
import IconLike from '@/components/displays/icons/IconLike.vue';
export default {
  components: {
    IconLike
  }
}
</script>

<style scoped>
</style>
